import {
  toast,
  ToastContentParams,
  ToastVariant,
  ToastOptions
} from '@redislabsdev/redis-ui-components';

export const showToast = (
  content: string | ToastContentParams,
  variant: ToastVariant = 'danger',
  options?: ToastOptions
) => toast(content, { variant, ...options });
